export default {"src":"/_next/static/media/zen-tree.ee3560ea.svg","height":170,"width":147,"blurWidth":0,"blurHeight":0};